import React from 'react';
import { PageHeader, PageLayout } from '../../components/ui/PageLayout';
import SystemBackupPanel from './SystemBackupPanel';
import FactoryResetPanel from './FactoryResetPanel';

export default function SystemBackupPage() {
  return (
    <PageLayout>
      <PageHeader title="Backup" description="Proteja o banco de dados e as imagens do sistema em um único arquivo." />
      <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm leading-relaxed text-amber-900">
        Salve uma cópia em um HD externo ou em outro computador. Um backup guardado apenas no mesmo disco pode ser perdido junto com o computador.
      </div>
      <SystemBackupPanel />
      <FactoryResetPanel />
    </PageLayout>
  );
}
